import { render, staticRenderFns } from "./GroupInfoForm.vue?vue&type=template&id=74f02320&"
import script from "./GroupInfoForm.vue?vue&type=script&lang=js&"
export * from "./GroupInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports